import { FC } from 'react';

export const Copyright: FC = () => (
  <section className="bg-brand py-2">
    <p className="text-center text-sm text-white"> Ⓒ COCOペット</p>
  </section>
);
